// extracted by mini-css-extract-plugin
export var button = "desktopFooter-module--button--dded9";
export var container = "desktopFooter-module--container--a1ee4";
export var divider = "desktopFooter-module--divider--b7b04";
export var header = "desktopFooter-module--header--3b14f";
export var headerCTA = "desktopFooter-module--headerCTA--5cfa3";
export var heading = "desktopFooter-module--heading--208ed";
export var heading4 = "desktopFooter-module--heading4--15c34";
export var inner = "desktopFooter-module--inner--489ba";
export var leftSection = "desktopFooter-module--leftSection--b0fd4";
export var link = "desktopFooter-module--link--e3ab5";
export var logo = "desktopFooter-module--logo--e507f";
export var paragraph = "desktopFooter-module--paragraph--f8772";
export var root = "desktopFooter-module--root--1eb4d";
export var socials = "desktopFooter-module--socials--682bf";